import { render } from "./DsBadge.vue?vue&type=template&id=6d20097e&scoped=true"
import script from "./DsBadge.vue?vue&type=script&lang=js"
export * from "./DsBadge.vue?vue&type=script&lang=js"

import "./DsBadge.vue?vue&type=style&index=0&id=6d20097e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d20097e"]])

export default __exports__